import { useDispatch, useSelector } from 'react-redux';
import { changeDeleteModalState } from '../../store/actionCreators';
import { deleteUser } from '../../store/searchAction';
import { StoreState } from '../../type.d';
import blueWarningIcon from '../../../images/blue-warning-icon.svg';
import Modal from 'react-bootstrap/Modal';
import closeIcon from '../../../images/close-icon.svg';
import * as Styled from './DeleteModalStyles';

const DeleteModal = () => {
  const dispatch = useDispatch();

  const { deleteModal } = useSelector((rootReducer: StoreState) => rootReducer.reducer);

  const ChangeDeleteModalState = () => dispatch(changeDeleteModalState());

  const handleDelete = () => {
    dispatch(deleteUser());
  }

  return (
    <Modal
      show={deleteModal}
      onHide={ChangeDeleteModalState}
      animation={false}
      centered
      size='sm'
      contentClassName='custom-content'
      dialogClassName='custom-dialog'
    >
      <Styled.StyledModalBody >
        <Styled.StyledModalBtn onClick={() => ChangeDeleteModalState()}
          className='HeaderBtn'
        >
          <Styled.StyledImg src={closeIcon} alt='Close' />
        </Styled.StyledModalBtn>
        <Styled.StyledParagraph>
          <p className="mb-0">Deleting your Trova account will permanently remove all your data from Trova.</p>
          <p>Are you sure you want to delete your account?</p>
        </Styled.StyledParagraph>
        <Styled.Container className="align-items-start">
          <img src={blueWarningIcon} alt="Warning" />
          <Styled.StyledSpan>
            You will not be able to reactivate your Trova account once deleted.
          </Styled.StyledSpan>
        </Styled.Container>
      </Styled.StyledModalBody>
      <Styled.StyledModalFooter>
        <Styled.StyledModalBtn onClick={handleDelete}
          className='DeleteStyles'
        >
          Delete
        </Styled.StyledModalBtn>
      </Styled.StyledModalFooter>
    </Modal>
  );
}

export default DeleteModal;